const AvailableforRentRouter = [
    {
        path: "list-available_for_rent",
        name: "list",
        component: () => import("@/views/admin/available_for_rent"),
        default: true,
        meta: {
            model: "available_for_rent",
            // requiresAuth: true,
        },
    },
    {
        path: "list-available_for_rent/add",
        name: "add",
        component: () => import("@/views/admin/available_for_rent/function"),
        default: true,
        meta: {
            model: "available_for_rent",
            // requiresAuth: true,
        },
    },
    {
        path: "list-available_for_rent/edit/:id",
        name: "edit",
        component: () => import("@/views/admin/available_for_rent/function"),
        default: true,
        meta: {
            model: "available_for_rent",
            // requiresAuth: true,
        },
    },
  ];
  export default AvailableforRentRouter;